var _defs, _rect, _rect2, _rect3, _rect4, _use, _ellipse, _circle, _circle2, _circle3, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWhyme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    role: "img",
    "aria-label": "Epicor expertise: Kinetic, BPMs, BAQs, SSRS, Functions and Dashboards",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun",
    cx: 0.08,
    cy: 1,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a582",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a582",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky",
    cx: 0.95,
    cy: 0,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb6e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30",
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f7fb5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb6e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "orbit",
    d: "M80 200a220 130 0 1 0 440 0a220 130 0 1 0 -440 0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sun)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sky)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#orbit",
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.35,
    strokeWidth: 1.5,
    strokeDasharray: "4 8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 200,
    rx: 150,
    ry: 88,
    fill: "none",
    stroke: "#f4a582",
    strokeOpacity: 0.18,
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#f4a582"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "14s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#4fb6e3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "14s",
    begin: "-7s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 205,
    r: 110,
    fill: "url(#halo)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 122l68 26v58c0 47-31 78-68 94c-37-16-68-47-68-94v-58z",
    fill: "url(#shield)",
    stroke: "#fbe3cf",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 136l55 21v49c0 39-25 65-55 79c-30-14-55-40-55-79v-49z",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270 208l20 20l40-44",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -16,
    width: 100,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "Kinetic")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490 135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -16,
    width: 92,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#f0926e",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "BPMs")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490 265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -16,
    width: 92,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "BAQs")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300 330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -16,
    width: 120,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#f0926e",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "Dashboards")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 265)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -56,
    y: -16,
    width: 112,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "Functions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -16,
    width: 92,
    height: 32,
    rx: 16,
    fill: "#0f2233",
    stroke: "#f0926e",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    fill: "#e8eaf0"
  }, "SSRS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhyme);
export default __webpack_public_path__ + "static/media/home-whyme.8623d2f718cfc1a472c4730f756e0f37.svg";
export { ForwardRef as ReactComponent };